<template>
<div class="curated-boxes-page">
  <div @click="goBack()" class="back-button">&lt; BACK</div>
  <div v-if="!isMobile" class="curated-boxes-images-container">
    <img class="main-image" :src="currentImage"/>
    <div class="sub-images-container">
      <div class="sub-image"  v-for="image in curatedBoxImages" :key="image">
        <img @click="selectImage(image)" v-bind:src="image"/>
      </div>
    </div>
  </div>
  <VueSlickCarousel v-else-if="curatedBoxImages.length > 0" :infinite="true" :dots="true" :arrows="false" :slidesToShow="1" :slidesToScroll="1">
    <div class="curated-boxes-images-container" v-for="image in curatedBoxImages" :key="image">
      <img class="main-image" :src="image"/>
    </div>
  </VueSlickCarousel>
  <div class="curated-boxes-main-container">
    <p class="main-title">{{curatedBoxTitle}}</p>
    <div class="box-qty-container">
      <div class="box-qty-input-container" :class="canAddMore ? '' : 'no-more'">
        <button :disabled="selectedBoxQty < 2" @click="incrementBoxQty(false)">-</button> 
        <input :disabled="true" @blur="changeBoxQty(null)" v-model="selectedBoxQty" type="number" min="1"> 
        <button v-tooltip="{content: 'Not enough inventory', container:false}" @click="incrementBoxQty(true)">+</button> 
      </div>
      <p class="price">{{currentPrice | intToDecimalPrice}}</p>
    </div>
    <p class="general-advice" v-if="!noDetails">Write your note and add to cart! If you’re buying multiple boxes, you will have the options to ship to different addresses at checkout.</p>
    <p v-else v-html="description"></p>
    <div class="product-tabs">
      <div class="tab-container">
        <button :class="selectedTab == tab.value ? 'selected' : ''" @click="selectTab(tab.value)" v-for="tab in tabs" :key="tab.value">{{tab.title}} <span></span></button>
      </div>
      <div class="tab-content" :class="tabValue == 1 ? 'products' : ''">
        <div class="write-container" v-if="selectedTab == 2 && !noCard">
            <div>
                <p class="purple-span">Type in your message below. A real human will hand write your message and include it in your gift.</p>
                <div class="blank-card-container">
                    <input v-model="isEmptyMessage" id="blankCard" type="checkbox">
                    <label for="blankCard">Click here if you want your card blank</label>
                </div>
            </div>
            <div v-if="!isEmptyMessage" class="form-container">
              <div class="message-container">
                  <p v-if="showAlert" class="red-alert">Please type your message below</p>
                  <label for="message">Your Message:</label>
                  <textarea :disabled="isEmptyMessage" placeholder="Start typing here..." maxlength="110" v-model="message.text" cols="30" rows="3" id="message"></textarea>
              </div>
              <div class="from-container">
                  <p v-if="showAlert" class="red-alert">Please type your message below</p>
                  <label for="from">From:</label>
                  <input :disabled="isEmptyMessage" placeholder="Your Name" maxlength="110" v-model="message.from" id="from" type="text">
                  <p class="purple-span">Character Remaining {{remainingCharacters}}</p>
              </div>
            </div>
        </div>
        <div class="description-container" v-if="selectedTab == 3 && !noDetails">
          <p v-html="description"></p>
        </div>
      </div>
    </div>
    <div class="end-buttons-container">
      <button @click="addToCart(true)" class="happybox-button yellow">Save and go to cart</button>
      <div class="separator">
        <div class="line-separator"></div>
        <div class="text">OR</div>
        <div class="line-separator"></div>
      </div>
      <button @click="toBuilder" class="happybox-button purple">Build a care package from scratch</button>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from "axios";
import VueSlickCarousel from 'vue-slick-carousel'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
require('dotenv').config();


export default {
  components: {
    VueSlickCarousel,
  },
  data(){
    return{
      selectedImage: null,
      didModify: false,
      selectedCard: null,
      isEmptyMessage: false,
      boxQty: 1,
      selectedBoxQty: 1,
      message: {
        text: "",
        from: ""
      },
      tabValue: null,
      showAlert: false,
    };
  },
  watch:{
    minQty: function(newVal,oldVal){
      this.changeBoxQty(newVal);
    },
  },
  computed:{
    ...mapGetters([
      'curatedBox',
      'cart',
      'minQty'
    ]),
    currentImage(){
      if (this.selectedImage){
        return this.selectedImage;
      }
      else if (this.curatedBox){
        return this.curatedBox.featured_image;
      }
    },
    curatedBoxTitle(){
      return this.curatedBox.title;
    },
    curatedBoxImages(){
      var images = []
      if(Object.keys(this.curatedBox).length != 0){
        images = this.curatedBox.images;
        var variantImages = this.curatedBox.variants.filter(x => x.featured_image).map(x => x.featured_image.src.replace("https:",""));
        images = images.filter(function(image) {
          return !variantImages.includes(image);
        });
      }
      return images;
    },
    currentPrice(){
      if(this.curatedBox)
        if(this.curatedBox.variants)
          return this.curatedBox.variants[0].price * this.boxQty;

      return 0
    },
    remainingCharacters(){
      var remainingCharacters = 110;
      remainingCharacters = remainingCharacters - (this.message.text.length + this.message.from.length)
      return remainingCharacters;
    },
    hasWrittenCard(){
      if(this.noCard){
        return true
      }
      else if(!this.isEmptyMessage){
        if(this.message.text.length > 0 && this.message.from.length > 0){
          return true
        }
        return false
      }
      else {
        return true;
      }
    },
    description(){
      if(this.curatedBox)
        return this.curatedBox.description;
      
      return '';
    },
    boxesOnCart(){
      let boxes = 0;

      if(this.cart && this.curatedBox && this.cart.items){
        var cartItem = this.cart.items.filter(x => x.product_id == this.curatedBox.id);
        if(cartItem){
          boxes = cartItem.reduce((prev, next) => prev + next.quantity, 0);;
        }

      }

      return boxes
    },
    maxBoxes(){
      let boxQty = 0 - this.boxesOnCart;
      if(this.curatedBox){
        if(this.curatedBox.variants){
          if(this.curatedBox.variants.length > 1)
            boxQty += this.curatedBox.variants.map(x => x.inventory_quantity).reduce((prev, next) => prev + next, 0);
          else 
            boxQty += this.curatedBox.variants[0].inventory_quantity;
        }  
      }

      return boxQty
    },
    canAddMore(){
      return this.boxQty < this.maxBoxes;
    },
    isMobile() {
      return window.innerWidth < 768;
    },
    noCard(){
      if(this.curatedBox){
        if(this.curatedBox.tags)
          return this.curatedBox.tags.includes("no_card")
      }

      return false;
    },
    noDetails(){
      if(this.curatedBox){
        if(this.curatedBox.tags)
          return this.curatedBox.tags.includes("no_details")
      }

      return false;
    },
    tabs(){
      if(this.noCard){
        return [{title:"Details",value:3}];
      }
      else if (this.noDetails)
        return [{title:"Write your note",value:2}]
      else 
        return [{title:"Write your note",value:2},{title:"Details",value:3}]
    },
    selectedTab(){
      if(this.tabValue)
        return this.tabValue
      else{
        if(this.noCard)
          return 3
        else 
          return 2
      }
    },
  },
  methods:{
    selectImage(image){
      this.selectedImage = image;
    },
    incrementBoxQty(increment){
      if(increment){
        this.changeBoxQty(this.boxQty + 1);
      }
      else {
          if(this.boxQty > 1){
            this.boxQty--;
            this.selectedBoxQty--;
          }
      }
    },
    changeBoxQty(qty){
      //Validate if cart products can support box qty if not show alert
      this.selectedBoxQty = qty ? qty : this.selectedBoxQty
      if(this.selectedBoxQty <= this.maxBoxes)
        this.boxQty = this.selectedBoxQty;
      else
        this.selectedBoxQty = this.boxQty;
    },
    selectTab(value){
      this.tabValue = value;
    },
    addToCart(redirect = false){
      if(!this.hasWrittenCard){
        this.tabValue = 2;
        this.showAlert = true;
        $('.separator')[0].scrollIntoView();
        return;
      }
      if(this.boxQty <= this.maxBoxes && this.boxQty > 0){
        var properties = {};
        properties["Message"] = this.message.text;
        properties["From"] = this.message.from;
        properties["LeaveCardBlank"] = this.isEmptyMessage;
        properties["_uniqueKey"] =  Date.now();
        this.ajaxAddCart({
          id: this.curatedBox.variants[0].id,
          quantity: this.boxQty,
          properties: properties,
        },redirect)
      }
    },
    ajaxAddCart(item,redirect) {
      axios
      .post("/cart/add.js", item)
      .then((response) => {
        let hasCart = localStorage.getItem("cartDate");
        if(!hasCart){
            let newDate = new Date();
            let stringDate = newDate.getFullYear() + "-"+ newDate.getMonth() + "-" + newDate.getDate();
            localStorage.setItem("cartDate",stringDate);
        }
        if(redirect){
          localStorage.setItem('openCart',true);
          window.location.href = "/";
        }
        else {
          $('.cartClicker, #AddToCart').click();
          this.updateCart();
        }
      })
      .catch((err) => {
          console.log(err);
      });
    },
    updateCart(){
      axios.get(`${STORE_URL}/cart.js`)
        .then(response => response.data)
        .then((data) => {
          this.$store.commit('setCart', data);
        })
    },
    toBuilder(){
      location.href = '/products/build-a-box'
    },
    goBack(){
      location.href = '/collections/happy-boxes'
    }
  },
  beforeMount(){
  },
  mounted() {
  },
  destroy() {
  }
}
</script>